import React, { useEffect } from "react";
import "../assets/styles/CenteredContainer.css";
import { useAuth } from "@clerk/clerk-react";

const CenteredContainer = ({ children }) => {
  return <div className="centered-container">{children}</div>;
};

export default CenteredContainer;
